import { render, staticRenderFns } from "./NewsPopup.vue?vue&type=template&id=f702e3fa&scoped=true"
import script from "./NewsPopup.vue?vue&type=script&lang=js"
export * from "./NewsPopup.vue?vue&type=script&lang=js"
import style0 from "./NewsPopup.vue?vue&type=style&index=0&id=f702e3fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f702e3fa",
  null
  
)

export default component.exports